import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Card, CardBody, Container, Button, Col, Row } from "reactstrap"
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Icon from "./components/Icon.js"

const itemArray = new Array(9).fill('empty')

const App = () => {
  const [isCross, setIsCross] = useState(false)
  const [winMessage, setWinMessage] = useState('')

  const ReloadGame = () => {
    setIsCross(false)
    setWinMessage('')
    itemArray.fill('empty', 0, 9)
  }
  const CheckIsWinner = () => {
    if (itemArray[0] !== "empty"
      && itemArray[0] === itemArray[1]
      && itemArray[1] === itemArray[2]) {
      setWinMessage(`${itemArray[0]} wins the match`);
    }
    if (itemArray[3] !== "empty"
      && itemArray[3] === itemArray[4]
      && itemArray[4] === itemArray[5]) {
      setWinMessage(`${itemArray[3]} wins the match`);
    }
    if (itemArray[6] !== "empty"
      && itemArray[6] === itemArray[7]
      && itemArray[7] === itemArray[8]) {
      setWinMessage(`${itemArray[6]} wins the match`);
    }
    if (itemArray[0] !== "empty"
      && itemArray[0] === itemArray[4]
      && itemArray[4] === itemArray[8]) {
      setWinMessage(`${itemArray[0]} wins the match`);
    }
    if (itemArray[2] !== "empty"
      && itemArray[2] === itemArray[4]
      && itemArray[4] === itemArray[6]) {
      setWinMessage(`${itemArray[2]} wins the match`);
    }
    if (itemArray[0] !== "empty"
      && itemArray[0] === itemArray[3]
      && itemArray[3] === itemArray[6]) {
      setWinMessage(`${itemArray[0]} wins the match`);
    }
    if (itemArray[1] !== "empty"
      && itemArray[1] === itemArray[4]
      && itemArray[4] === itemArray[7]) {
      setWinMessage(`${itemArray[1]} wins the match`);
    }
    if (itemArray[2] !== "empty"
      && itemArray[2] === itemArray[5]
      && itemArray[5] === itemArray[8]) {
      setWinMessage(`${itemArray[2]} wins the match`);
    }
    else if (itemArray[0] !== "empty" && itemArray[1] !== "empty" && itemArray[2] !== "empty" && itemArray[3] !== "empty"
      && itemArray[4] !== "empty" && itemArray[5] !== "empty" && itemArray[6] !== "empty" && itemArray[7] !== "empty"
      && itemArray[8] !== "empty") {
      setWinMessage(`Match Draw`);
    }

  }
  const ChangeItem = ItemNumber => {
    if (winMessage) {
      return toast(winMessage, { type: "success" })
    }
    if (itemArray[ItemNumber] === "empty") {
      itemArray[ItemNumber] = isCross ? "cross" : "circle";

      setIsCross(!isCross)

    }
    else {
      return toast('already filled', { type: "error" })
    }
    CheckIsWinner();
  };


  return (
    <div>
      <Container className='p-5'>
        <ToastContainer position="bottom-center" />
        <Row>

          <Col md={6} className="offset-md-3">
            <h1 className="text-white">Hello and welcome,Glad to see you here!!!!</h1>
            {winMessage ? (
              <div className="mb-2 mt-2">

                <h1 className="text-success text-uppercase text-center">
                  {winMessage}
                </h1>
                <Button id="ok" onClick={ReloadGame}>ReloadGame</Button>
              </div>
            ) : (
              <h1 className="text-warning text-center">
                {isCross ? "Cross" : "Circle"} turn
              </h1>
            )
            }
            <div className="grid">
              {itemArray.map((item, index) => (
                <Card color="warning" onClick={() => ChangeItem(index)}>
                  <CardBody className="box">
                    <Icon Name={item} />
                  </CardBody>
                </Card>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
